import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { PublicWebSocketProvider } from '../../contexts/PublicWebSocketContext';
import EventPopupLayout from './EventPopupLayout';
import FullTimelineLayout from './FullTimelineLayout';
import ScoreboardTop from './ScoreboardTop';
import AllLayersLayout from './AllLayersLayout';

/**
 * Layout Router for Public Watch Views
 * Routes to different layouts based on query parameter
 * 
 * Usage:
 * /watch/:matchId?layout=event-popup
 * /watch/:matchId?layout=full-timeline (default)
 * /watch/:matchId?layout=scoreboard-top
 * /watch/:matchId?layout=all-layers (IGSON single HTML5)
 */
export const LayoutRouter = () => {
  const { matchId } = useParams();
  const [searchParams] = useSearchParams();
  const layout = searchParams.get('layout') || 'full-timeline';

  const renderLayout = () => {
    switch (layout) {
      case 'event-popup':
        return <EventPopupLayout matchId={parseInt(matchId)} />;
      
      case 'scoreboard-top':
        return <ScoreboardTop matchId={parseInt(matchId)} />;
      
      case 'all-layers':
        return <AllLayersLayout matchId={parseInt(matchId)} />;
      
      case 'full-timeline':
      default:
        return <FullTimelineLayout matchId={parseInt(matchId)} />;
    }
  };

  return (
    <PublicWebSocketProvider>
      {renderLayout()}
    </PublicWebSocketProvider>
  );
};

export default LayoutRouter;
